import { useCallback, useState } from 'react';
import useToggle from '../useToggle';

export function useToggleReportRow(hasOccurrences: boolean) {
  const { isOpen, toggle, open, close } = useToggle(false);
  const [isCreatingOccurrence, setIsCreatingOccurrence] = useState(false);

  const toggleRow = useCallback(() => {
    const nextIsOpen = !isOpen;
    toggle();
    setIsCreatingOccurrence(nextIsOpen && !hasOccurrences);
  }, [isOpen, hasOccurrences, toggle]);

  const openOccurrenceForm = useCallback(() => {
    open();
    setIsCreatingOccurrence(true);
  }, [open]);

  const closeOccurrenceForm = useCallback(
    () => setIsCreatingOccurrence(false),
    [],
  );

  const cancelOccurrenceForm = useCallback(() => {
    if (!hasOccurrences) {
      close();
    }
    setIsCreatingOccurrence(false);
  }, [hasOccurrences, close]);

  return {
    isOpen,
    isCreatingOccurrence,
    toggleRow,
    openOccurrenceForm,
    closeOccurrenceForm,
    cancelOccurrenceForm,
  };
}
